import script from "./EditQRPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQRPage.vue?vue&type=script&setup=true&lang=js"

import "./EditQRPage.vue?vue&type=style&index=0&id=e84a585e&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e84a585e"]])

export default __exports__